import {TvVendor} from './tv-vendor';
import {TvVendorModule} from './tv-vendor-module';
import {inject} from '../di';

/**
 * Config containing information on how to determine the current TV vendor and where its executable module is located.
 */
export const TV_VENDOR_DETECTION_CONFIG: {[tvVendor in TvVendor]: TvVendorDetectionConfig} = {
  [TvVendor.Loewe]: {
    probes: ['loewe'],
    moduleResolver: () => import(`../../vendors/loewe/loewe`).then((m) => inject(m.LoeweVendorModule)),
  },
  [TvVendor.Amino]: {
    probes: ['amino'],
    moduleResolver: () => import(`../../vendors/amino/amino`).then((m) => inject(m.AminoVendorModule)),
  },
  [TvVendor.LG]: {
    probes: ['lge', 'netcast', 'lg browser'],
    moduleResolver: () => import(`../../vendors/lg/lg`).then((m) => inject(m.LgVendorModule)),
  },
  [TvVendor.TizenTep]: {
    probes: ['tizen 6.5', 'tizen 7.0', 'tizen 9.0'],
    moduleResolver: () => import(`../../vendors/tizen-tep/tizen-tep`).then((m) => inject(m.TizenTepVendorModule)),
  },
  [TvVendor.Tizen]: {
    probes: ['tizen'],
    moduleResolver: () => import(`../../vendors/tizen/tizen`).then((m) => inject(m.TizenVendorModule)),
  },
  [TvVendor.Samsung]: {
    probes: ['smarthub', 'smart-tv', 'maple'],
    moduleResolver: () => import(`../../vendors/samsung/samsung`).then((m) => inject(m.SamsungVendorModule)),
  },
  [TvVendor.PhilipsOld]: {
    probes: ['opera', 'presto', 'hbbtv'],
    moduleResolver: () => import(`../../vendors/philips-old/philips-old`).then((m) => inject(m.PhilipsOldVendorModule)),
  },
  [TvVendor.Philips]: {
    probes: ['philipstv', 'japit', 'wixp'],
    moduleResolver: () => import(`../../vendors/philips/philips`).then((m) => inject(m.PhilipsVendorModule)),
  },
  [TvVendor.Tvip]: {
    probes: ['tvip', 'mag200 stbapp ver: 3'],
    moduleResolver: () => import(`../../vendors/tvip/tvip`).then((m) => inject(m.TvipVendorModule)),
  },
  [TvVendor.Mag]: {
    probes: ['mag200', 'stbapp ver: 4'],
    moduleResolver: () => import(`../../vendors/mag/mag`).then((m) => inject(m.MagVendorModule)),
  },
  [TvVendor.Sony]: {
    probes: ['bravia', 'sonycebrowser'],
    moduleResolver: () => import(`../../vendors/sony/sony`).then((m) => inject(m.SonyVendorModule)),
  },
  [TvVendor.Vestel]: {
    probes: ['vestel', 'smarttva'],
    moduleResolver: () => import(`../../vendors/vestel/vestel`).then((m) => inject(m.VestelVendorModule)),
  },
  [TvVendor.AndroidTv]: {
    probes: ['android'],
    moduleResolver: () => import(`../../vendors/android-tv/android-tv`).then((m) => inject(m.AndroidTvVendorModule)),
  },
  [TvVendor.Desktop]: {
    // default one
    probes: [],
    moduleResolver: () => import(`../../vendors/desktop/desktop`).then((m) => inject(m.DesktopVendorModule)),
  },
};

export type TvVendorDetectionConfig = {
  /**
   * Vendor module resolver
   */
  moduleResolver: () => Promise<TvVendorModule>;

  /**
   * A list of keywords that should appear in the browser's UserAgent string. Lower case only.
   */
  probes: string[];
};
